import React, { useEffect, useState } from "react";
import { useUserDetails } from "../../../redux/hooks/UserDetails";
import { useTheme } from '../../../redux/hooks/useTheme';
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../Dashboard/SubComponents/Header";
import Footer from "../Dashboard/SubComponents/Footer";
import { Sub } from "@radix-ui/react-context-menu";
import "./Subscription.css"

const Subscription = () => {
    const { userDetail } = useUserDetails();
    const { theme } = useTheme();
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate(); 
  const location = useLocation();

  useEffect(() => {
    if (userDetail && Object.keys(userDetail).length > 0) {
      setIsLoading(false); // Stop loading when `userDetail` is populated
    }
  }, [userDetail]);
  // Extract data from userDetail
  const {
    email = "N/A",
    name = "N/A",
    ogCompanyName = "N/A",
    customEnhanceLimit=0,
    customUploadImageLimit=0,
 extraCreditId={},
    ogSubscriptionId = {},
    customDomainLimit= false,
    inLineEditorLimit=false,
    totalAppsCreated=0,
    totalLeadsCreated=0,
  } = userDetail || {};
console.log("userDetail", userDetail);
  const { planName = "N/A", features = [] } = ogSubscriptionId;
  const {  display_Plan_name = "N/A",dailyChatLimit=0,monthlyChatLimit=0, totalAppsCount = 0,
    totalLeadsCount = 0, uploadImageLimit = 0, enhanceMagicLimit = 0 ,
  } = ogSubscriptionId;
 
 const{extraCreditCustomEnhanceLimit=0,extraCreditCustomUploadImageLimit=0,extraCreditDailyChatLimit=0,extraCreditMonthlyChatLimit=0,extraCreditTotalAppsCount=0,extraCreditTotalLeadsCount=0}=extraCreditId


  const additionalFeatures = [
    { name: 'Unlimited chats with AI', limited: planName !== 'Premium' },
    { name: 'Access to pre-made tools', limited: planName !== 'Premium' },
    { name: 'Upload images directly in chat', limited: planName === 'Basic' },
    { name: 'Enhanced user interface customization', limited: planName === 'Basic' },
    { name: 'Ability to host applications', limited: planName !== 'Premium' },
    { name: 'Embed applications seamlessly into web pages', limited: planName === 'Basic' },
];


// const handleBack = () => {
//     if (window.history.length > 2) {
//         navigate(-1);
//     } else {
//       // Default to home or another fallback route
//       navigate("/");
//     }
//   };

  if (isLoading) {
    return (
        <div className="flex justify-center items-center h-screen">
        <img
          src="https://dlvkyia8i4zmz.cloudfront.net/r3tQgGlrTJmcKpUvZ5Kk_loader.svg"
          alt="main loader"
        />
      </div>
    );
  }

  return (
    <div  style={{backgroundColor:theme.leadFormPopUp}}>
    <Header/>
    <div style={{backgroundColor:theme.planPg, borderRadius:'14px'}} className="plan-container mx-auto p-[30px]">
      {/* Back Button */}
      {/* <button 
  className="text-gray-600 text-sm flex items-center mb-4 gap-2 md:gap-3 lg:gap-4"
  onClick={handleBack}
>
  <span 
    className="flex items-center gap-2 text-[14px] font-normal" 
    style={{ color: theme.planBackButton }}
  > 
    <span className="flex justify-center items-center">
      <svg 
        width="8" 
        height="8" 
        viewBox="0 0 11 9" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="w-3 h-3 md:w-4 md:h-4 lg:w-4 lg:h-4"
      >
        <path 
          d="M9.82177 3.76796C9.91795 3.76793 10.0132 3.78684 10.1021 3.82361C10.1909 3.86038 10.2717 3.9143 10.3397 3.98228C10.4077 4.05027 10.4617 4.13098 10.4985 4.21982C10.5354 4.30867 10.5544 4.40389 10.5544 4.50007C10.5544 4.59624 10.5355 4.69149 10.4987 4.78035C10.462 4.86922 10.4081 4.94998 10.3401 5.01801C10.2721 5.08604 10.1914 5.14001 10.1025 5.17685C10.0137 5.21368 9.91846 5.23266 9.82229 5.23269L9.82177 3.76796ZM1.03544 4.50007L0.517687 5.01783C0.38037 4.88051 0.303226 4.69427 0.303226 4.50007C0.303226 4.30587 0.38037 4.11963 0.517687 3.98231L1.03544 4.50007ZM3.81269 0.687312C3.95001 0.549994 4.13625 0.47285 4.33044 0.47285C4.52464 0.47285 4.71088 0.549994 4.8482 0.687312C4.98552 0.824629 5.06266 1.01087 5.06266 1.20507C5.06266 1.39926 4.98552 1.58551 4.8482 1.72282L3.81269 0.687312ZM4.8482 7.27732C4.98552 7.41463 5.06266 7.60088 5.06266 7.79507C5.06266 7.98927 4.98552 8.17551 4.8482 8.31283C4.71088 8.45015 4.52464 8.52729 4.33045 8.52729C4.13625 8.52729 3.95001 8.45015 3.81269 8.31283L4.8482 7.27732ZM9.82229 5.23269L1.03493 5.2327L1.03544 3.76796L9.82177 3.76796L9.82229 5.23269ZM0.517687 3.98231L3.81269 0.687312L4.8482 1.72282L1.5532 5.01783L0.517687 3.98231ZM1.5532 3.98231L4.8482 7.27732L3.81269 8.31283L0.517687 5.01783L1.5532 3.98231Z"
          fill="currentColor"
        />
      </svg>
    </span>
    <span>Back</span>
  </span>
</button> */}


      {/* Title */}
      <h2 
        className="mb-1 text-[22px] sm:text-[24px] md:text-[26px] lg:text-[28px] font-semibold leading-[28px] sm:leading-[30px] md:leading-[32px] lg:leading-[33px]" 
        style={{ color: theme.viewMoreHeading }}
      >
        Subscription
      </h2>
      {/* <p style={{fontSize:'14px', fontWeight:'400', lineHeight:'22px', color:theme.viewMoreSubHeading}} >
        Easily access the details of your current plan, including features,
        usage limits, and available upgrades.
      </p>
      <p style={{fontSize:'14px', fontWeight:'400', lineHeight:'22px', color:theme.viewMoreSubHeading}}>Stay informed and make the most of your subscription</p> */}

      {/* User Details Section */}
      <div 
  className="p-6 rounded-lg mt-6  bg-white dark:bg-gray-900" 
  style={{ borderColor: theme.viewPlanBorder, backgroundColor: theme.yourDetailsCard }}
>
  <div className="w-full md:w-[60%]">
  
    <div className="flex flex-col sm:flex-row sm:justify-between gap-4">
     
      <div>
        <p className="text-sm font-normal" style={{ color: theme.viewMoreSubHeading }}>Company Name</p>
        <p className="text-[20px] font-medium" style={{ color: theme.planBackButton }}>{ogCompanyName}</p>
      </div>
    </div>
  </div>
</div>


      {/* Plan Section */}
      <div
  style={{ background: theme.planSection }}
  className="rounded-[14px] border sidebar-bordre pb-6 p-[24px] sm:px-6 lg:px-8 mt-6"
>
  <div className="rounded-[14px] mt-6 text-white">
    <div
      style={{ borderColor: theme.viewPlanBorderIn }}
      className="flex flex-wrap justify-between border-b items-center pb-[24px]"
    >
      <div className="flex flex-col">
        <p
          style={{ color: theme.planTags }}
          className="text-sm sm:text-base font-normal"
        >
          Plan
        </p>
        <p
          style={{ color: theme.planBackButton }}
          className="capitalize text-lg sm:text-xl font-medium"
        >
          { display_Plan_name}
        </p>
      </div>

      <div className="flex gap-2 text-sm sm:text-base">
        <span style={{ color: theme.planTags }}>Plans managed by</span>
        {/* <img src="https://dlvkyia8i4zmz.cloudfront.net/LL65hffcT0GXRjlzNN1W_Vector__31_.svg" /> */}
        <span style={{ color: theme.planTags }}>Autoolic</span>
      </div>
    </div>
  </div>

  {/* Usage Section */}
  <div
    style={{ borderColor: theme.viewPlanBorderIn }}
    className="pt-6"
  >
    {/* <h2
      style={{ color: theme.planBackButton }}
      className="text-lg sm:text-xl font-semibold mb-4"
    >
      Usage
    </h2> */}
    {/* provide live tools count here */}

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {/* Total Tools */}
 <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
  <div className="flex justify-between">
    <p style={{ color: theme.planTags }} className="text-sm">
      Total Tools
    </p>
    <div className="relative flex items-center">
      {/* This wrapper is the group */}
      <div className="relative group">
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-4 h-4 cursor-pointer"
        >
          <path
            d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

        {/* Tooltip only shows on hover of SVG (parent div has group) */}
        <div className="absolute top-full right-0 mt-2 w-64 bg-black text-white text-xs px-3 py-2 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-normal break-words pointer-events-none">
          This is the total number of tools you can create and use in your account. Extra credit increases your tool limit.
        </div>
      </div>
    </div>
  </div>
  <p style={{ color: theme.count }} className="text-2xl font-medium">
    {totalAppsCreated} / {totalAppsCount === -1 ? 'Unlimited' : totalAppsCount + (extraCreditTotalAppsCount > 0 ? extraCreditTotalAppsCount : 0)}
  </p>
  {totalAppsCount !== -1 && extraCreditTotalAppsCount > 0 && (
    <p style={{ color: theme.extraCredit }} className="text-sm mt-2">
      Extra Credit for Total Tools: {extraCreditTotalAppsCount}
    </p>
  )}
</div>




      {/* Total Leads */}
      <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
        <div className="flex justify-between">
          <p style={{ color: theme.planTags }} className="text-sm">Total Leads</p>
          <div className=" relative flex items-center">
            <div className="relative group">
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4 cursor-pointer"
              
            >
              
              <path
                d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <div className="absolute top-full right-0 mt-2 w-64 bg-black text-white text-xs px-3 py-2 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-normal break-words pointer-events-none">
              This is the total number of leads you can collect with your account. Extra credit increases your leads limit.
            </div>
          </div>
          </div>
        </div>
        <p style={{ color: theme.count }} className="text-2xl font-medium">
           {totalLeadsCreated} / {totalLeadsCount === -1 ? 'Unlimited' : totalLeadsCount + (extraCreditTotalLeadsCount > 0 ? extraCreditTotalLeadsCount : 0)}
        </p>
        {totalLeadsCount !== -1 && extraCreditTotalLeadsCount > 0 && (
          <p style={{ color: theme.extraCredit }} className="text-sm mt-2">
            Extra Credit for Total Leads: {extraCreditTotalLeadsCount}
          </p>
        )}
      </div>
   {/* dailyChatLimit */}
   {planName === "free_y" && (
                                <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
                                    <div className="flex justify-between">
                                        <p style={{ color: theme.planTags }} className="text-sm">
                                            Daily Chat Limit
                                        </p>
                                       <div className="relative flex items-center">
      {/* This wrapper is the group */}
      <div className="relative group">
                                            <svg
                                                width="16"
                                                height="17"
                                                viewBox="0 0 16 17"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="w-4 h-4"
                                                style={{ cursor: 'pointer' }}
                                            >
                                              {/* <title></title> */}
                                                <path
                                                    d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                                                    stroke="currentColor"
                                                    strokeWidth="1.3"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        <div className="absolute top-full right-0 mt-2 w-64 bg-black text-white text-xs px-3 py-2 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-normal break-words pointer-events-none">
 This is the maximum number of chats you can have per day. Extra credit increases your daily chat limit.   
      </div>
                                    </div>
                                    </div>
                                    </div>
                                    
                                    <p style={{ color: theme.count }} className="text-2xl font-medium">
                                           {dailyChatLimit + (extraCreditDailyChatLimit > 0 ? extraCreditDailyChatLimit : 0)}
                                        </p>
                                        {extraCreditDailyChatLimit > 0 && (
                                        <p style={{ color: theme.extraCredit }} className="text-sm mt-2">
                                            Extra Credit for Total DailyChats: {extraCreditDailyChatLimit}
                                        </p>
                                        )}
                                </div>
                            )}

         {/* monthely chat limit */}
         <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
        <div className="flex justify-between">
          <p style={{ color: theme.planTags }} className="text-sm">
           Monthly Chat Limit
          </p>
 <div className="relative flex items-center">
      {/* This wrapper is the group */}
      <div className="relative group">
                    <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4"
              style={{ cursor: 'pointer' }}
            >
              {/* <title></title> */}
              <path
                d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          <div className="absolute top-full right-0 mt-2 w-64 bg-black text-white text-xs px-3 py-2 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-normal break-words pointer-events-none">
This is the maximum number of chats you can have per month. Extra credit increases your monthly chat limit. 
       </div>
      </div>
    </div>
        </div>
        <p style={{ color: theme.count }} className="text-2xl font-medium">
            {monthlyChatLimit + (extraCreditMonthlyChatLimit > 0 ? extraCreditMonthlyChatLimit : 0)}
                                        </p>
                                        {extraCreditMonthlyChatLimit > 0 && (
                                        <p style={{ color: theme.extraCredit }} className="text-sm mt-2">
                                            Extra Credit for Total MonthlyChats: {extraCreditMonthlyChatLimit}
                                        </p>
                                        )}
      </div>
         {/* CUSTOM DOMAIN limit */}
         {/* <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
        <div className="flex justify-between">
          <p style={{ color: theme.planTags }} className="text-sm">
            CUSTOM DOMAIN
          </p>
          <span className="flex items-center">
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4"
              style={{ cursor: 'pointer' }}
            >
              <title>Indicates whether you have access to the custom domain feature. </title>
              <path
                d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        </div>
        <p style={{ color: theme.count }} className="text-2xl font-medium">
          {customDomainLimit ? "Yes" : "No"}
        </p>
      </div> */}

         {/* INLINE EDITOR limit */}
         <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
        <div className="flex justify-between">
          <p style={{ color: theme.planTags }} className="text-sm">
            Inline Editor
          </p>
         <div className="relative flex items-center">
      {/* This wrapper is the group */}
      <div className="relative group">
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4"
              style={{ cursor: 'pointer' }}
            >
              {/* <title>
              </title> */}
              <path
                d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          {/* Tooltip only shows on hover of SVG (parent div has group) */}
        <div className="absolute top-full right-0 mt-2 w-64 bg-black text-white text-xs px-3 py-2 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-normal break-words pointer-events-none">
              Indicates whether you have access to the inline editor feature.
        </div>
      </div>
    </div>
  </div>
        <p style={{ color: theme.count }} className="text-2xl font-medium">
          {inLineEditorLimit ? "Yes" : "No"}
        </p>
      </div>

{/* enhance Magic limit */}
<div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
        <div className="flex justify-between">
          <p style={{ color: theme.planTags }} className="text-sm">
            Enhance Magic Limit
          </p>
 <div className="relative flex items-center">
      {/* This wrapper is the group */}
      <div className="relative group">
                    <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4"
              style={{ cursor: 'pointer' }}
            >
{/* <title> </title> */}
              <path
                d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
         {/* Tooltip only shows on hover of SVG (parent div has group) */}
        <div className="absolute top-full right-0 mt-2 w-64 bg-black text-white text-xs px-3 py-2 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-normal break-words pointer-events-none">
 This is the maximum number of times you can use the Enhance Magic feature per tool. Extra credit increases this limit.        </div>
      </div>
    </div>

        </div>
        <p style={{ color: theme.count }} className="text-2xl font-medium">
          {enhanceMagicLimit + (extraCreditCustomEnhanceLimit > 0 ? extraCreditCustomEnhanceLimit : 0)}
        </p>
        {extraCreditCustomEnhanceLimit > 0 && (
          <p style={{ color: theme.extraCredit }} className="text-sm mt-2">
            Extra Credit for Enhance Magic per Tool: {extraCreditCustomEnhanceLimit}
          </p>
        )}
      </div>

      {/* upload image limit */}
      <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
        <div className="flex justify-between">
          <p style={{ color: theme.planTags }} className="text-sm">
            Upload Image Limit
          </p>
           <div className="relative flex items-center">
      {/* This wrapper is the group */}
      <div className="relative group">
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4"
              style={{ cursor: 'pointer' }}
            >
             {/* <title></title> */}
              <path
                d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
         <div className="absolute top-full right-0 mt-2 w-64 bg-black text-white text-xs px-3 py-2 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-normal break-words pointer-events-none">
  This is the maximum number of images you can upload per tool. Extra credit increases this limit.        </div>
      </div>
    </div>
  </div>
        <p style={{ color: theme.count }} className="text-2xl font-medium">
          {uploadImageLimit + (extraCreditCustomUploadImageLimit > 0 ? extraCreditCustomUploadImageLimit : 0)}
        </p>
        {extraCreditCustomUploadImageLimit > 0 && (
          <p style={{ color: theme.extraCredit }} className="text-sm mt-2">
            Extra Credit for Upload Image per Tool: {extraCreditCustomUploadImageLimit}
          </p>
        )}
      </div>


      {/* Features */}
      {/* {features.length > 0 ? (
        features.map((feature:any, index:any) => (
          <div key={index} style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4">
            <div className="flex justify-between">
              <p style={{ color: theme.planTags }} className="text-sm">{feature.name}</p>
              <span className="flex items-center">
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4"
                >
                  <path
                    d="M8.00964 1.84155C4.33235 1.84155 1.35132 4.82259 1.35132 8.49988C1.35132 12.1772 4.33235 15.1582 8.00964 15.1582C11.6869 15.1582 14.668 12.1772 14.668 8.49988C14.668 4.82259 11.6869 1.84155 8.00964 1.84155Z"
                    stroke="currentColor"
                    strokeWidth="1.3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path d="M8.00977 11.1633V8.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M8.00977 5.83667H8.00227" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </div>
            <p style={{ color: theme.count }} className="text-2xl font-medium">
               {feature._id === 'enhance_magic' && extraCreditCustomEnhanceLimit > 0
                                                ? feature.limit + extraCreditCustomEnhanceLimit
                                                : feature._id === 'upload_image' && extraCreditCustomUploadImageLimit > 0
                                                ? feature.limit + extraCreditCustomUploadImageLimit
                                                : feature.limit}
                                            </p>
                                            {feature._id === 'enhance_magic' && extraCreditCustomEnhanceLimit > 0 && (
                                            <p style={{ color: theme.extraCredit }} className="text-sm mt-2">
                                                Extra Credit for Enhance Magic per Tool: {extraCreditCustomEnhanceLimit}
                                            </p>
                                            )}
                                            {feature._id === 'upload_image' && extraCreditCustomUploadImageLimit > 0 && (
                                            <p style={{ color: theme.extraCredit }} className="text-sm mt-2">
                                                Extra Credit for Upload Image per Tool: {extraCreditCustomUploadImageLimit}
                                            </p>
                                            )}
          </div>
        ))
      ) : (
        <div style={{ backgroundColor: theme.usageSection }} className="rounded-lg p-4 text-center">
          <p style={{ color: theme.planTags }} className="text-sm">No features available</p>
        </div>
      )} */}
    </div>
  </div>
</div>

    </div>
    <Footer/>
    </div>
  );
};

export default Subscription;
